import { NonNullableSettingConfig } from "./NonNullableSettingConfig";
import { Dictionary } from "./Dictionary";

export const DictionarySetting: NonNullableSettingConfig<Dictionary> = {
  type: "dictionary",
  serialize: (value: Dictionary): string => {
    return JSON.stringify(value);
  },

  deserialize: (value: string): Dictionary => {
    return JSON.parse(value);
  },
};
